import { render, staticRenderFns } from "./DispatchPatternSaveConfirmDialog.vue?vue&type=template&id=b6730068&scoped=true&lang=pug"
import script from "./DispatchPatternSaveConfirmDialog.vue?vue&type=script&lang=js"
export * from "./DispatchPatternSaveConfirmDialog.vue?vue&type=script&lang=js"
import style0 from "./DispatchPatternSaveConfirmDialog.vue?vue&type=style&index=0&id=b6730068&prod&scoped=true&lang=stylus"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6730068",
  null
  
)

export default component.exports